import { Modal } from "@components";
import type { CommonPrescription } from "@interfaces";
import { Typography } from "@mui/material";

const ActionTextMapper: Record<CommonPrescription["type"], string> = {
  SIMPLE: "Dispensar",
  HELD: "Retener",
  COMPOUNDED_PRESCRIPTION: "Retener",
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  prescription: CommonPrescription;
}

export const DispenseOrHoldWarningModal = ({
  isOpen,
  onClose,
  onSubmit,
  prescription,
}: Props) => {
  const content = `No podrás revertir, liberar ni volver a usar esta receta.`;

  return (
    <Modal
      title="Acción irreversible"
      content={
        <Typography variant="body1" textAlign="left">
          {content}
        </Typography>
      }
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        buttonText: `${ActionTextMapper[prescription.type]}`,
        onClick: () => {
          onClose();
          onSubmit();
        },
      }}
    ></Modal>
  );
};
